import { Injectable } from "@angular/core";
import { Api } from "../api/api";
import { Observable } from "rxjs/Observable";
import { Board } from "../../models/board";
import { AlertController } from "ionic-angular";
import { User } from "../../models/user";
import { Image } from "../../models/image";
import { BasicProperty } from "../../models/property";
import { SearchParamsBoards } from "../../providers/user/user";

@Injectable()
export class BoardProvider {
  boards: Board[];
  boardData: any[];
  boardInclude: any[];

  constructor(public api: Api, public alertCtrl: AlertController) {}

  create(board: Board): Observable<any> {
    return this.api.post("me/boards", this.buildFormData(board), true);
  }

  update(board: Board): Observable<any> {
    return this.api.put(
      `me/boards/${board.id}`,
      this.buildFormData(board),
      true
    );
  }

  delete(id: number): Observable<any> {
    return this.api.delete(`me/boards/${id}`, true);
  }

  async loadMyIndex(): Promise<Board[]> {
    const url: string = "me/boards";
    return this.getBoards(url);
  }

  async load(
    params: SearchParamsBoards,
    shownBoardIds: number[]
  ): Promise<Board[]> {
    const url: string = "boards";
    let loadParams: any = {};
    loadParams = {
      query: JSON.stringify(params),
      shown_board_ids: JSON.stringify(shownBoardIds),
    };
    return this.getBoards(url, loadParams);
  }

  private getBoards(url: string, loadParams?: string): Promise<Board[]> {
    return new Promise<Board[]>((resolve, reject) => {
      this.api.get(url, true, loadParams).subscribe(
        (data: any) => {
          this.boards = [];
          this.boardData = [];
          this.boardInclude = [];
          this.boardData = this.boardData.concat(data.data);
          this.boardInclude = this.boardInclude.concat(data.included);

          for (let i = 0; i < this.boardData.length; i++) {
            let userId = this.boardData[i].relationships.user.data.id;
            for (let j = 0; j < this.boardInclude.length; j++) {
              if (this.boardInclude[j].id !== userId) continue;
              if (this.boardInclude[j].id === userId) {
                let board: Board = new Board({
                  id: this.boardData[i].attributes.id,
                  reserved_date: this.boardData[i].attributes.reserved_date,
                  timeframe: this.boardData[i].attributes.timeframe,
                  area: this.boardData[i].attributes.area,
                  area_detail: this.boardData[i].attributes.area_detail,
                  purpose: this.boardData[i].attributes.purpose,
                  free_text: this.boardData[i].attributes.free_text,
                  hide_when_matched:
                    this.boardData[i].attributes.hide_when_matched,
                  image_url: this.boardData[i].attributes.image_url,
                  created_at: this.boardData[i].attributes.created_at,
                  user: new User({
                    id: this.boardInclude[j].attributes.id,
                    age: this.boardInclude[j].attributes.age,
                    nickname: this.boardInclude[j].attributes.nickname,
                    residence_location:
                      this.boardInclude[j].attributes.residence_location,
                    top_image: new Image({
                      image_url: this.boardInclude[j].attributes.image_url,
                    }),
                  }),
                });
                this.boards.push(board);
                break;
              }
            }
          }
          return resolve(this.boards);
        },
        (error) => {
          this.showloadError();
          return reject(error);
        }
      );
    });
  }

  private buildFormData(board): FormData {
    const formData: FormData = new FormData();
    formData.append("reserved_date", board.reserved_date);
    formData.append("timeframe", board.timeframe);
    formData.append("area", board.area);
    formData.append("area_detail", board.area_detail);
    formData.append("purpose", board.purpose);
    formData.append("free_text", board.free_text);
    formData.append("hide_when_matched", board.hide_when_matched.toString());
    if (board.id) formData.append("id", board.id);
    // NOTE: image と image_urlの説明はmodels/board.tsに記載
    if (board.image) {
      // 新規作成時or編集で画像が追加された場合
      const blobImage: Blob = this.toBlob(board.image);
      formData.append("image", blobImage, board.image.name);
    }
    if (!board.image && !board.image_url) {
      // 編集で画像が消去された時
      formData.append("image", "");
    }
    // 画像に変更がない場合はパラメータにimageを追加しない
    return formData;
  }

  private toBlob(base64: string): Blob {
    const bin = atob(base64[1].replace(/^.*,/, ""));
    let buffer = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) {
      buffer[i] = bin.charCodeAt(i);
    }
    const blob = new Blob([buffer.buffer], { type: "image/png" });
    return blob;
  }

  private showloadError(): void {
    const alert = this.alertCtrl.create({
      title: "エラー",
      subTitle: "取得に失敗しました",
      buttons: [
        {
          text: "OK",
        },
      ],
    });
    alert.present();
  }

  generateBoardIds(targetBoards: Board[]): number[] {
    let boardIds: number[] = [];
    targetBoards.forEach((board: Board) => {
      boardIds.push(board.id);
    });
    return boardIds;
  }
}



// WEBPACK FOOTER //
// ./src/providers/board/board.ts